module.exports = __webpack_public_path__ + "static/img/process-blue-point.fd37f2d2.png";